/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTicketPdfRequest } from '../../models/get-ticket-pdf-request';

export interface PostGeneratePdf$Params {
  body?: GetTicketPdfRequest;
}

export function postGeneratePdf(
  http: HttpClient,
  rootUrl: string,
  params?: PostGeneratePdf$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, postGeneratePdf.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'arraybuffer', accept: 'application/pdf', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    }),
  );
}

postGeneratePdf.PATH = '/Tickets/generate-pdf';
